module.exports = __webpack_public_path__ + "img/0Q3A8622_L_Wood_MockedUp.818fd61a.jpg";